import React from 'react'
import HolidaySettings from '../Components/Holiday/HolidaySettings'

const HolidayManagementPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <HolidaySettings/>
    </div>
  )
}

export default HolidayManagementPage
